import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {LegendDto, ReorderLegendDto} from '@maporium-workspace/shared';
import {isInIframe} from '../../shared/helpers/maporium.validators';

@Injectable({providedIn: 'root'})
export class LegendResource {
  private readonly baseUrl = environment.apiUrl + '/legends';
  private readonly publicBaseUrl = environment.apiUrl + '/public/legends';

  constructor(private http: HttpClient) {
  }

  get(mapId: string) {
    const url = isInIframe() ? this.publicBaseUrl : this.baseUrl;
    return this.http.get<LegendDto | null>(url + '?mapId=' + mapId);
  }

  getOrCreate(mapId: string) {
    return this.http.post<LegendDto>(this.baseUrl, {mapId});
  }

  toggleModelInclusion(modelId: string, mapId: string, included: boolean) {
    return this.http.patch<any>(this.baseUrl + '/' + modelId + '/toggle', {mapId, included});
  }

  reorder(mapId: string, items: ReorderLegendDto['items']) {
    return this.http.post<LegendDto>(this.baseUrl + '/reorder', {mapId, items});
  }

  removeModel(modelId: string, mapId: string) {
    return this.http.delete<{ message: string }>(this.baseUrl + '/' + modelId + '?mapId=' + mapId);
  }
}
